import { useEffect } from "react";
import { auth } from '@/firebase';
import { useNavigate } from "react-router-dom";
import { Button, Stack } from "@mui/material"
import GoogleIcon from '@/assets/icons/google-icon.svg';
import { GoogleAuthProvider, onAuthStateChanged, signInWithPopup } from "firebase/auth";
import routes from '@/constants/routes';
import { useFormikContext } from "formik";
import { OnboardingFormValues } from "../Onboarding";
import { useAppDispatch } from "@/hooks";
import { setUser } from "@/features/auth/slice";

const AuthenticationStep = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { values } = useFormikContext<OnboardingFormValues>();

    const signInWithGoogle = async () => {
        const provider = await new GoogleAuthProvider();
        return signInWithPopup(auth, provider);
    }

    // const signInWithFacebook = () => {
    //     //
    // }

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user: any) => {
            if (user) {
                dispatch(
                    setUser({
                        uid: user.uid,
                        email: user.email,
                        emailVerified: user.emailVerified,
                    })
                );

                navigate(routes.onboarding.setup, {
                    state: {
                        ...values,
                        user: {
                            uid: user.uid,
                            email: user.email,
                            emailVerified: user.emailVerified,
                        }
                    },
                });
            }
        });

        return () => {
            unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values]);

    return (
        <Stack spacing={2}>
            <Button
                fullWidth
                size="large"
                onClick={signInWithGoogle}
                startIcon={<img src={GoogleIcon} alt="Google" />}
                sx={{
                    color: 'black',
                    backgroundColor: 'white',
                }}
            >
                Google
            </Button>
        </Stack>
    )
}

export default AuthenticationStep;
